module.exports = __webpack_public_path__ + "145a2408fe75b533e72e8caa9a0ed8fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/09_PROP_VET_11-2.png
// module id = 109
// module chunks = 0